export function trackEvent(type, payload = {}) {
  try {
    const source = detectSource();
    const body = JSON.stringify({ type, referrer: document.referrer || null, source, ...payload });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
  } catch (e) { /* non blocking */ }
}

function detectSource() {
  const ref = (document.referrer || "").toLowerCase();
  if (!ref) return "direct";
  if (ref.includes("facebook") || ref.includes("fb.")) return "facebook";
  if (ref.includes("instagram")) return "instagram";
  if (ref.includes("twitter") || ref.includes("t.co") || ref.includes("x.com")) return "twitter";
  if (ref.includes("youtube")) return "youtube";
  if (ref.includes("linkedin")) return "linkedin";
  if (ref.includes("google")) return "google";
  if (ref.includes(window.location.hostname)) return "internal";
  return "referral";
}
